import {
  Box,
  Checkbox,
  ListItemText,
  MenuItem,
  TextField
} from '@material-ui/core';
import {
  State,
  StateTransitionCondition,
  WorkflowParams
} from '@sierralabs/workflow';
import { useEffect } from 'react';
import { useFindGroups } from '../../../groups/Group.hooks';
import { Group } from '../../../groups/Group.interface';
import { TaskContext } from '../../../tasks/Task.machine';

import {
  TransitionConditionConfiguratorProps,
  TransitionConditionDisplayProps,
  TransitionConditionPlugin
} from '../TransitionConditionPlugin';

const CheckTeamConfigurator: React.FC<TransitionConditionConfiguratorProps> = ({
  taskType,
  event,
  condition,
  onChange
}) => {
  // get teams for permission conditions
  const { groupList, get: findGroups } = useFindGroups();
  useEffect(() => findGroups({ limit: 100 }), [findGroups]);

  return (
    <Box mt={2}>
      <TextField
        select={Boolean(groupList)}
        disabled={!groupList}
        variant='outlined'
        fullWidth
        label={groupList?.data ? 'Team Permission' : 'Loading...'}
        helperText='Pick a team that has the appropriate permission to perform this transition.'
        value={condition.params?.groupIds || []}
        SelectProps={{
          multiple: true,
          renderValue: (selected: any) =>
            selected
              .map((value: number) => groupList?.data.find(g => g.id === value))
              .map((g: Group) => g.name)
              .join(', '),
          onChange: event => {
            if (condition.params) {
              condition.params.groupIds = event.target.value;
              console.log('onChange', event.target.value);
              onChange?.({ ...condition });
            }
          }
        }}
      >
        {groupList?.data?.map(group => (
          <MenuItem key={group.id} value={group.id}>
            <Checkbox
              color='primary'
              checked={
                condition?.params?.groupIds
                  ? condition.params.groupIds.indexOf(group.id) > -1
                  : false
              }
            />
            <ListItemText primary={group.name} />
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

const CheckTeamDisplay: React.FC<TransitionConditionDisplayProps> = ({
  condition
}) => {
  return <>Check Team Permission</>;
};

export const CheckTeamPlugin: TransitionConditionPlugin = {
  type: 'check-team',
  label: 'Check Team Permission',
  configurator: CheckTeamConfigurator,
  display: CheckTeamDisplay,
  validate: (condition: Partial<StateTransitionCondition>) => {
    return true;
  },
  guard: (state: State<TaskContext>, params: WorkflowParams) => {
    // console.log('guards: check-team', state, params);
    const groupIds: number[] = params?.groupIds || [];
    // make sure user has group permission to transition
    if (
      !state.context?.user.groups ||
      !state.context?.user.groups.some(userGroup =>
        groupIds.some(id => id === userGroup.id)
      )
    ) {
      return false;
    }
    return true;
  }
};
